// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".MuiSwitch-colorPrimary.Mui-checked {\n  color: #23c723 !important; }\n\n.MuiSwitch-colorPrimary.Mui-checked + .MuiSwitch-track {\n  background-color: #4b944b !important; }\n\n.MuiSwitch-sizeSmall .MuiSwitch-thumb {\n  width: 15px !important;\n  height: 15px !important;\n  border: 1px solid #86868685 !important; }\n", ""]);
// Exports
module.exports = exports;
